/* eslint-disable react/jsx-one-expression-per-line */
import * as React from "react";

// Misc.
import packageJson from "../../../package.json";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dw-grey-14 pt-5 pb-5 sm:pb-4">
      <div className="w-11/12 mx-auto relative">
        <div className="text-white font-bold text-xs flex flex-wrap">
          <p className="text-dw-grey-06 font-normal mr-2 mb-1">
            &copy; {currentYear} Deutsche Welle{" "}
            <span className="text-2xs block">v {packageJson.version}</span>
          </p>
          <a
            className="mr-2 mb-1"
            href="https://www.dw.com/en/european-union-general-data-protection-regulationgdpr-valid-may-25-2018/a-18265246"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            className="mr-2 mb-1"
            href="https://www.dw.com/en/legal-notice/a-15718492"
            target="_blank"
            rel="noopener noreferrer"
          >
            Legal
          </a>
          <a
            className="mr-2 mb-1"
            href="https://www.dw.com/en/service/contact/s-30606"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
